import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, ApiHttpError } from '~/lib/api/client'
import type {
  AdminListUser,
  AdminsListResponse,
  AdminUpdatePayload,
} from '~/lib/api/types'

export const ADMINS_QUERY_KEY = ['admins'] as const

export function useAdmins(enabled = true) {
  return useQuery<AdminsListResponse, ApiHttpError>({
    queryKey: ADMINS_QUERY_KEY,
    queryFn: () => api.listAdmins(),
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
    enabled,
  })
}

// One mutation for both flags — the endpoint is the same, the payload
// carries which one is being changed.
export function useSetAdmin() {
  const qc = useQueryClient()
  return useMutation<
    AdminListUser,
    ApiHttpError,
    { id: string; payload: AdminUpdatePayload }
  >({
    mutationFn: ({ id, payload }) => api.setAdmin(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMINS_QUERY_KEY }),
  })
}
